import { render, staticRenderFns } from "./DlgMemberDelete.vue?vue&type=template&id=45a3b092&scoped=true"
import script from "./DlgMemberDelete.vue?vue&type=script&lang=js"
export * from "./DlgMemberDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a3b092",
  null
  
)

export default component.exports